export const cleanMailBody = (body: string): string => {
  return body
    .replaceAll(/(color:(\s)?rgb\((\s)?0(\s)?,(\s)?0(\s)?,(\s)?0(\s)?\))|(color="#000000")/gim, '')
    .replaceAll(/<meta\s[^>]+>/igm, '')
    .replaceAll(/<base([\s\S]+?)>/igm, '')
    .replaceAll(/<style([\s\S]+?)<\/style>/igm, '')
    .replaceAll(/<script[^>]*>((.|[\n\r])*)<\/script>/igm, '');
};
